import {Component} from '@angular/core';
import {NavigationComponent} from "../components/navigation.component";
import {SidebarComponent} from "../components/sidebar.component";
import {RouterOutlet} from "@angular/router";

@Component({
    selector: 'app-page',
    imports: [NavigationComponent, SidebarComponent, RouterOutlet],
    styles: `
        @media (min-width: 768px) {
            main {
                padding-left: 270px;
                margin-top: 55px;
            }
        }
        @media (max-width: 768px) {
            main {
                margin-top: 70px;
            }
        }
    `,
    template: `
        <app-sidebar/>
        <app-navigation/>

        <div class="container-fluid bg-body-tertiary" style="min-height: 100vh">
            <div class="row">
                <main class="col-sm-12">
                    <div class="px-md-3 py-md-4 px-1 pb-3">
                        <router-outlet/>
                    </div>
                </main>
            </div>
        </div>
    `
})
export class PageComponent {

}
